import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "card-header viewer-header" };
const _hoisted_2 = { class: "card-title" };
const _hoisted_3 = { class: "viewer-toolbar" };
const _hoisted_4 = { class: "viewer-body" };
const _hoisted_5 = {
    key: 0,
    class: "viewer-empty"
};
const _hoisted_6 = {
    key: 1,
    class: "bit-grid"
};
const _hoisted_7 = { class: "bit-addr" };
const _hoisted_8 = { class: "bit-value" };
const _hoisted_9 = { class: "mono" };
const _hoisted_10 = {
    key: 0,
    class: "span-hint"
};
const _hoisted_11 = { class: "mono raw-cell" };
const _hoisted_12 = { class: "mono value-cell" };
import { computed, ref } from 'vue';
import { useStore } from 'vuex';
import { DataLine } from '@element-plus/icons-vue';
import { REGISTER_DECODE_OPTIONS, getFunctionMeta } from '@/core/modbus/constants';
import { decodeRegisters, formatByRadix } from '@/core/modbus/format';
export default /*@__PURE__*/ _defineComponent({
    __name: 'RegisterViewer',
    props: {
        channel: {}
    },
    setup(__props) {
        const props = __props;
        const store = useStore();
        const BYTE_ORDERS = ['ABCD', 'CDAB', 'BADC', 'DCBA'];
        const radix = ref('HEX');
        const decodeType = ref('uint16');
        const byteOrder = ref('ABCD');
        const bits = computed(() => store.getters[`${props.channel}/lastBits`]);
        const registers = computed(() => store.getters[`${props.channel}/lastRegisters`]);
        const startAddress = computed(() => store.getters[`${props.channel}/lastStartAddress`]);
        const functionCode = computed(() => store.getters[`${props.channel}/lastFunctionCode`]);
        const isBitMode = computed(() => getFunctionMeta(functionCode.value & 0x7f)?.dataType === 'bit');
        const isEmpty = computed(() => isBitMode.value ? bits.value.length === 0 : registers.value.length === 0);
        const wordsPerValue = computed(() => REGISTER_DECODE_OPTIONS.find((o) => o.value === decodeType.value)?.words ?? 1);
        const decodeLabel = computed(() => REGISTER_DECODE_OPTIONS.find((o) => o.value === decodeType.value)?.label ?? '值');
        const bitItems = computed(() => bits.value.map((on, i) => ({ address: startAddress.value + i, on })));
        const decodedRows = computed(() => decodeRegisters(registers.value, decodeType.value, byteOrder.value, startAddress.value));
        function formatAddress(addr) {
            return radix.value === 'DEC' ? String(addr) : `0x${addr.toString(16).padStart(4, '0').toUpperCase()}`;
        }
        function formatRaw(raw) {
            return raw.map((v) => formatByRadix(v, radix.value, 16)).join(' ');
        }
        function formatDecoded(value) {
            // 浮点数保持十进制展示，转成二进制/十六进制没有意义
            if (decodeType.value === 'float32' || decodeType.value === 'float64') {
                return Number.isFinite(value) ? value.toFixed(4) : String(value);
            }
            if (radix.value === 'DEC')
                return String(value);
            const bitWidth = wordsPerValue.value * 16;
            // 负数先转成对应位宽的补码再格式化
            const unsigned = value < 0 ? value >>> 0 : value;
            return formatByRadix(unsigned, radix.value, bitWidth);
        }
        return (_ctx, _cache) => {
            const _component_el_option = _resolveComponent("el-option");
            const _component_el_select = _resolveComponent("el-select");
            const _component_el_tooltip = _resolveComponent("el-tooltip");
            const _component_el_radio_button = _resolveComponent("el-radio-button");
            const _component_el_radio_group = _resolveComponent("el-radio-group");
            const _component_el_icon = _resolveComponent("el-icon");
            const _component_el_switch = _resolveComponent("el-switch");
            const _component_el_table_column = _resolveComponent("el-table-column");
            const _component_el_table = _resolveComponent("el-table");
            const _component_el_card = _resolveComponent("el-card");
            return (_openBlock(), _createBlock(_component_el_card, { class: "mb-card" }, {
                header: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                        _createElementVNode("span", _hoisted_2, _toDisplayString(isBitMode.value ? '线圈 / 离散输入状态' : '寄存器数据'), 1),
                        _createElementVNode("div", _hoisted_3, [
                            (!isBitMode.value)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _cache[5] || (_cache[5] = _createElementVNode("span", { class: "toolbar-label" }, "数据类型", -1)),
                                    _createVNode(_component_el_select, {
                                        modelValue: decodeType.value,
                                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((decodeType).value = $event)),
                                        size: "small",
                                        style: { "width": "132px" }
                                    }, {
                                        default: _withCtx(() => [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(REGISTER_DECODE_OPTIONS), (opt) => {
                                                return (_openBlock(), _createBlock(_component_el_option, {
                                                    key: opt.value,
                                                    label: opt.label,
                                                    value: opt.value
                                                }, null, 8, ["label", "value"]));
                                            }), 128))
                                        ]),
                                        _: 1
                                    }, 8, ["modelValue"]),
                                    _createVNode(_component_el_tooltip, { placement: "top" }, {
                                        content: _withCtx(() => _cache[3] || (_cache[3] = [
                                            _createTextVNode(" 多寄存器组合时的排列顺序", -1),
                                            _createElementVNode("br", null, null, -1),
                                            _createTextVNode(" ABCD 大端（最常见）· CDAB 字交换", -1),
                                            _createElementVNode("br", null, null, -1),
                                            _createTextVNode(" BADC 字节交换 · DCBA 小端 ", -1)
                                        ])),
                                        default: _withCtx(() => [
                                            _cache[4] || (_cache[4] = _createElementVNode("span", { class: "toolbar-label" }, "字节序", -1))
                                        ]),
                                        _: 1,
                                        __: [4]
                                    }),
                                    _createVNode(_component_el_select, {
                                        modelValue: byteOrder.value,
                                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((byteOrder).value = $event)),
                                        size: "small",
                                        style: { "width": "96px" },
                                        disabled: wordsPerValue.value === 1
                                    }, {
                                        default: _withCtx(() => [
                                            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(BYTE_ORDERS, (o) => {
                                                return _createVNode(_component_el_option, {
                                                    key: o,
                                                    label: o,
                                                    value: o
                                                }, null, 8, ["label", "value"]);
                                            }), 64))
                                        ]),
                                        _: 1
                                    }, 8, ["modelValue", "disabled"])
                                ], 64))
                                : _createCommentVNode("", true),
                            _cache[9] || (_cache[9] = _createElementVNode("span", { class: "toolbar-label" }, "显示", -1)),
                            _createVNode(_component_el_radio_group, {
                                modelValue: radix.value,
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((radix).value = $event)),
                                size: "small"
                            }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_el_radio_button, { value: "HEX" }, {
                                        default: _withCtx(() => _cache[6] || (_cache[6] = [
                                            _createTextVNode("HEX", -1)
                                        ])),
                                        _: 1,
                                        __: [6]
                                    }),
                                    _createVNode(_component_el_radio_button, { value: "DEC" }, {
                                        default: _withCtx(() => _cache[7] || (_cache[7] = [
                                            _createTextVNode("DEC", -1)
                                        ])),
                                        _: 1,
                                        __: [7]
                                    }),
                                    _createVNode(_component_el_radio_button, { value: "BIN" }, {
                                        default: _withCtx(() => _cache[8] || (_cache[8] = [
                                            _createTextVNode("BIN", -1)
                                        ])),
                                        _: 1,
                                        __: [8]
                                    })
                                ]),
                                _: 1
                            }, 8, ["modelValue"])
                        ])
                    ])
                ]),
                default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_4, [
                        (isEmpty.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                _createVNode(_component_el_icon, { size: 32 }, {
                                    default: _withCtx(() => [
                                        _createVNode(_unref(DataLine))
                                    ]),
                                    _: 1
                                }),
                                _cache[10] || (_cache[10] = _createElementVNode("p", null, "暂无数据", -1)),
                                _cache[11] || (_cache[11] = _createElementVNode("span", null, "发送一次读取请求后，解析结果会显示在这里", -1))
                            ]))
                            : (isBitMode.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(bitItems.value, (item) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                            key: item.address,
                                            class: _normalizeClass(["bit-cell", { on: item.on }])
                                        }, [
                                            _createElementVNode("div", _hoisted_7, _toDisplayString(formatAddress(item.address)), 1),
                                            _createVNode(_component_el_switch, {
                                                "model-value": item.on,
                                                disabled: "",
                                                size: "small"
                                            }, null, 8, ["model-value"]),
                                            _createElementVNode("div", _hoisted_8, _toDisplayString(item.on ? 'ON' : 'OFF'), 1)
                                        ], 2));
                                    }), 128))
                                ]))
                                : (_openBlock(), _createBlock(_component_el_table, {
                                    key: 2,
                                    data: decodedRows.value,
                                    size: "small",
                                    border: "",
                                    stripe: "",
                                    "max-height": "360",
                                    class: "reg-table"
                                }, {
                                    default: _withCtx(() => [
                                        _createVNode(_component_el_table_column, {
                                            label: "地址",
                                            width: "120"
                                        }, {
                                            default: _withCtx(({ row }) => [
                                                _createElementVNode("span", _hoisted_9, _toDisplayString(formatAddress(row.address)), 1),
                                                (row.words > 1)
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_10, "+" + _toDisplayString(row.words - 1), 1))
                                                    : _createCommentVNode("", true)
                                            ]),
                                            _: 1
                                        }),
                                        _createVNode(_component_el_table_column, {
                                            label: "原始值",
                                            "min-width": "150"
                                        }, {
                                            default: _withCtx(({ row }) => [
                                                _createElementVNode("span", _hoisted_11, _toDisplayString(formatRaw(row.raw)), 1)
                                            ]),
                                            _: 1
                                        }),
                                        _createVNode(_component_el_table_column, {
                                            label: decodeLabel.value,
                                            "min-width": "140"
                                        }, {
                                            default: _withCtx(({ row }) => [
                                                _createElementVNode("span", _hoisted_12, _toDisplayString(formatDecoded(row.value)), 1)
                                            ]),
                                            _: 1
                                        }, 8, ["label"])
                                    ]),
                                    _: 1
                                }, 8, ["data"]))
                    ])
                ]),
                _: 1
            }));
        };
    }
});
